const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20celebrity%20gossip%20concept%20with%20microphone%20and%20spotlight%20on%20dark%20stage%2C%20dramatic%20red%20and%20gold%20lighting%2C%20cinematic%20photography%20style%2C%20mysterious%20atmosphere%20with%20soft%20bokeh%20effects%2C%20editorial%20magazine%20quality%2C%20warm%20coral%20tones%20with%20deep%20shadows&width=600&height=400&seq=91crab-carousel-01&orientation=landscape',
    tag: '娱乐圈',
    title: '娱乐圈最新爆料合集',
    desc: '整理近期娱乐圈热门爆料事件完整录像，涵盖明星恋情、综艺争议、影视圈动态等热门吃瓜话题。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20breaking%20news%20concept%20with%20glowing%20notification%20icons%20and%20digital%20screens%2C%20modern%20urban%20cityscape%20background%2C%20warm%20amber%20and%20coral%20lighting%2C%20abstract%20data%20visualization%20elements%2C%20dynamic%20and%20fast%20paced%20atmosphere%2C%20editorial%20news%20style&width=600&height=400&seq=91crab-carousel-02&orientation=landscape',
    tag: '社会热点',
    title: '社会热点事件追踪',
    desc: '关注近期引发广泛讨论的社会热点事件，第一时间整理事件脉络与完整视频资料，让你全面了解事件真相。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20setup%20with%20ring%20light%20and%20camera%20equipment%2C%20modern%20content%20creator%20workspace%2C%20warm%20ambient%20lighting%20with%20neon%20accents%2C%20professional%20streaming%20gear%20on%20wooden%20desk%2C%20creative%20atmosphere%20with%20soft%20shadows%2C%20cinematic%20composition&width=600&height=400&seq=91crab-carousel-03&orientation=landscape',
    tag: '网红争议',
    title: '网红主播争议实录',
    desc: '收录近期网红主播圈的热门争议事件全程录像，包括直播翻车、人设崩塌、互撕大战等精彩吃瓜内容。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Variety%20show%20stage%20with%20colorful%20lighting%20and%20confetti%2C%20entertainment%20TV%20production%20concept%2C%20warm%20golden%20spotlight%20on%20empty%20stage%2C%20dramatic%20theatrical%20atmosphere%2C%20broadcast%20studio%20equipment%20visible%2C%20professional%20television%20production%20quality%2C%20vibrant%20and%20energetic&width=600&height=400&seq=91crab-carousel-04&orientation=landscape',
    tag: '综艺名场面',
    title: '综艺节目名场面回顾',
    desc: '回顾热门综艺节目中的经典名场面与争议片段，整理选手对决、导师互呛、意外爆点等让人印象深刻的高能时刻。',
  },
];

const rankingItems = [
  { rank: 1, title: '某顶流明星疑似恋情曝光全程录像', heat: '98.7万', tag: '爆' },
  { rank: 2, title: '知名网红直播翻车完整版回放', heat: '85.3万', tag: '热' },
  { rank: 3, title: '某综艺选手现场怒怼导师名场面', heat: '76.2万', tag: '热' },
  { rank: 4, title: '娱乐圈最新合约纠纷独家爆料', heat: '64.8万', tag: '新' },
  { rank: 5, title: '某品牌代言人争议事件始末整理', heat: '58.1万', tag: '热' },
  { rank: 6, title: '热门主播私下聚会视频流出', heat: '42.5万', tag: '新' },
  { rank: 7, title: '某综艺节目录制现场意外事件', heat: '35.9万', tag: '新' },
];

function getRankStyle(rank: number): string {
  if (rank === 1) return 'bg-primary-500 text-background-50';
  if (rank === 2) return 'bg-accent-500 text-background-50';
  if (rank === 3) return 'bg-secondary-500 text-background-50';
  return 'bg-background-200 text-foreground-500';
}

function getTagStyle(tag: string): string {
  if (tag === '爆') return 'bg-primary-500 text-background-50';
  if (tag === '热') return 'bg-accent-500 text-background-50';
  return 'bg-secondary-500 text-background-50';
}

export default function CarouselRankingSection() {
  return (
    <>
      <section id="carousel" className="relative py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              热门专题
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
              精选近期最具话题度的吃瓜专题，一站式浏览完整内容
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {carouselItems.map((item, idx) => (
              <div
                key={idx}
                className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full aspect-[3/2] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                      if (target.parentElement) {
                        target.parentElement.style.display = 'none';
                      }
                    }}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="inline-block px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-xs font-medium text-primary-600 rounded-md whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="font-heading text-base text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="ranking" className="relative py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              吃瓜榜单
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
              实时热门吃瓜话题排行榜，看看大家都在关注什么
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            {rankingItems.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-4 py-3.5 px-4 border-b border-background-200/70 last:border-b-0 hover:bg-background-50 rounded-lg transition-colors duration-200 cursor-pointer"
              >
                <span
                  className={`w-7 h-7 flex items-center justify-center rounded-md text-xs font-bold flex-shrink-0 ${getRankStyle(item.rank)}`}
                >
                  {item.rank}
                </span>
                <span className="flex-1 text-sm text-foreground-800 truncate">{item.title}</span>
                <span
                  className={`inline-block px-2 py-0.5 text-[10px] font-bold rounded whitespace-nowrap flex-shrink-0 ${getTagStyle(item.tag)}`}
                >
                  {item.tag}
                </span>
                <span className="text-xs text-foreground-400 flex-shrink-0 whitespace-nowrap">{item.heat}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}